exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._3Bnw{background:#f5f5f5;color:#333}._25ZI{margin:0 auto;padding:20px 8px;max-width:1000px;text-align:center;font-size:1.5em}.TNFJ,.TNFJ:active,.TNFJ:hover,.TNFJ:visited{color:#333;text-decoration:none}.TNFJ:hover{text-decoration:underline}._2fqq{padding-right:15px;padding-left:15px}", ""]);

// exports
exports.locals = {
	"root": "_3Bnw",
	"root": "_3Bnw",
	"container": "_25ZI",
	"container": "_25ZI",
	"link": "TNFJ",
	"link": "TNFJ",
	"spacer": "_2fqq",
	"spacer": "_2fqq"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"camelCase":true,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:4]","minimize":true}!../~/postcss-loader?pack=default!./components/Loader/Loader.css
// module id = 212
// module chunks = 0